export const ROW_HEIGHT = 36;
export const HEADER_HEIGHT = 36;
export const ADD_COLUMN_BUTTON_WIDTH = 36;
export const MIN_COLUMN_WIDTH = 60;
export const ROW_ID_COLUMN_ID = `\0_INDEX`;
export const TRUNCATE_LONG_CELL_WIDTH = 780;
export const PINNED_COLUMN_Z_INDEX = 1;
export const DEFAULT_FONT_SIZE = "12.5px";
